<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="auto">
      <v-card>
        <v-toolbar flat dark color="primary" class="max-height">
          <v-toolbar-title v-if="postgrado"> {{ postgrado.nombre }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn> -->
          <!-- <h3 class="text-center text-primary">{{ programa.nombre }}</h3> -->
          <p class="text-center">Aqui usted podra ver todos los programas de este postgrado implementados en las diferentes sedes.</p>

          <v-skeleton-loader :loading="!programas.length" transition="scale-transition" height="500" type="table">
            <v-data-table :headers="headers" :items="programas" class="elevation-10" :items-per-page="-1" hide-default-footer>
              <!-- <template v-slot:[`item.fase`]="{ item }" :color="getFaseColor(item.fase)">
                <b>item.fase</b>
                <span color="primary">135</span>
              </template> -->
            </v-data-table>
          </v-skeleton-loader>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded outlined color="primary" @click="closeDialog"> <v-icon> mdi-close</v-icon> cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { parseFasePrograma, parseModalidadInverse } from '@/components/Utils.js';
import gql from 'graphql-tag';

export default {
  data() {
    return {
      msg: '',
      estado: true,
      dialog: false,
      postgrado: null,
      idpostgrado: 0,
      programas: [],
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Codigo', value: 'codigo' },
        { text: 'Nombre', value: 'nombre_compuesto' },
        { text: 'gestion', value: 'gestion' },
        { text: 'Sede', value: 'sede.nombre' },
        // { text: 'Categoria', value: 'categoria.nombre' },
        // { text: 'Area', value: 'area.nombre' },
        { text: 'fecha_inicio', value: 'fecha_inicio' },
        { text: 'fecha_fin ', value: 'fecha_fin' },
        { text: 'version', value: 'version' },
        { text: 'fase', value: 'fase' },
        // { text: 'modalidad', value: 'modalidad' },
        { text: 'Inscritos', value: 'inscritos' },
        // { text: 'Pre Ins.', value: 'pre_inscritos' },
      ],
    };
  },
  components: {},
  methods: {
    showThisView(item) {
      this.postgrado = item;
      this.dialog = true;
      this.getDatos();
    },
    parseFechas(p) {
      var ini = [];
      var fin = [];
      var i = '';
      var f = '';
      if (p.fecha_inicio) ini = p.fecha_inicio.split('-');
      if (p.fecha_fin) fin = p.fecha_fin.split('-');
      if (ini.length > 1) i = ini[2] + '/' + ini[1] + '/' + ini[0];
      if (fin.length > 1) f = fin[2] + '/' + fin[1] + '/' + fin[0];
      return i + '  - \n' + f;
    },
    getFaseColor(fase) {
      if (fase == 0) return 'background:#e94646';
      if (fase == 1) return 'background:#D9F0D9';
      else if (fase == 2) return 'background:#A8FFA8';
      else if (fase == 3) return 'background:#EFFFA8';
      else if (fase == 4) return 'background:#FFC8A8';
      else return '';
    },
    getSede(sede) {
      if (sede == null) return '-';
      else return sede.nombre;
    },
    getDatos() {
      const qs = gql`query{ getPostgrado(id:${this.postgrado.id}){ programas{ id,codigo,nombre_compuesto,fecha_inicio,fecha_fin,version,estado,modalidad,gestion,fase,sede{nombre},inscripciones{id,estado_ins} } } }`;
      // window.console.log(qs);
      this.$apollo
        .query({ query: qs })
        .then(({ data: { getPostgrado } }) => {
          this.programas = getPostgrado.programas.map((program, i) => {
            program.index = ++i;
            program.fase = parseFasePrograma(program.fase);
            program.modalidad = parseModalidadInverse(program.modalidad);
            program.inscritos = program.inscripciones.filter((ins) => ins.estado_ins >= 1).length;
            program.pre_inscritos = program.inscripciones.filter((ins) => ins.estado_ins == 0).length;
            return program;
          });
        })
        .catch(() => this.$root.$notify.show(`No hay datos`, { color: 'primary' }));
    },
    closeDialog() {
      this.dialog = false;
      this.postgrado = null;
    },
  },
};
</script>